/* nm-pdp.js · ficha de producto: variantes, cantidad, galería, barra fija móvil y descripción del catálogo (limpia y colapsable). */
(function () {
  'use strict';
  var NM = window.NM = window.NM || {};
  var $ = function (s, r) { return (r || document).querySelector(s); }, $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var form = $('#pdp-form'), jsonEl = $('#pdp-json');

  /* ---------- descripción: preservar HTML editorial (fnx-self + <style>) ---------- */
  var src = $('#pdp-desc-src'), out = $('#pdp-desc');
  if (src && out) {
    var frag = src.content ? src.content.cloneNode(true) : null;
    if (frag) {
      var wrap = document.createElement('div'); wrap.appendChild(frag);
      var hasFnx = !!wrap.querySelector('.fnx-self, [class*="fnx-"]');
      /* CTA duplicados del body_html: la compra es la del tema */
      $$('a[href^="#"]', wrap).forEach(function (n) { if (/add|cart|buy|comprar|agreg/i.test((n.getAttribute('href') || '') + ' ' + n.textContent)) n.remove(); });
      /* peligroso fuera; STYLE se conserva (diseño editorial del producto) */
      $$('script,link,meta,iframe,object,embed,form,canvas,noscript,button,input,select,textarea', wrap).forEach(function (n) { n.remove(); });
      $$('*', wrap).forEach(function (n) {
        [].slice.call(n.attributes).forEach(function (a) {
          var k = a.name.toLowerCase();
          /* Conservar class/id/style: el layout fnx depende de ellos */
          if (k.indexOf('on') === 0) n.removeAttribute(a.name);
          if (k.indexOf('data-') === 0 && k !== 'data-open') n.removeAttribute(a.name);
        });
        if (n.tagName === 'A') {
          var h = n.getAttribute('href') || '';
          if (/^\s*javascript:/i.test(h)) n.removeAttribute('href');
          else if (/^https?:/i.test(h)) { n.setAttribute('rel', 'noopener'); n.setAttribute('target', '_blank'); }
        }
        if (n.tagName === 'IMG') {
          n.setAttribute('loading', 'lazy');
          if (!n.hasAttribute('alt')) n.setAttribute('alt', '');
        }
      });
      if (!hasFnx) {
        /* HTML plano legacy: normalizar headings */
        $$('h1,h2,h3,h4,h5,h6', wrap).forEach(function (h) {
          var n = +h.tagName.charAt(1), lvl = n <= 2 ? 2 : (n === 3 ? 3 : 4);
          if (lvl === n) return;
          var nh = document.createElement('h' + lvl); nh.innerHTML = h.innerHTML; h.replaceWith(nh);
        });
        $$('table', wrap).forEach(function (t) { var d = document.createElement('div'); d.className = 'tbl'; t.parentNode.insertBefore(d, t); d.appendChild(t); });
        $$('details', wrap).forEach(function (d) { d.classList.add('acc'); });
        /* Estilos en línea fijos (paneles navy, texto claro) → clases con tokens del tema, para que siga claro/oscuro */
        $$('[style]', wrap).forEach(function (n) {
          var st = n.style, bg = st.backgroundColor || '', bi = st.backgroundImage || '', col = st.color || '';
          if ((bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') || (bi && bi !== 'none')) { st.removeProperty('background'); st.removeProperty('background-color'); st.removeProperty('background-image'); n.classList.add('dx-card'); }
          if (col) {
            var m = col.match(/\d+(\.\d+)?/g) || [], r = +m[0], g = +m[1], b = +m[2];
            var mx = Math.max(r, g, b), mn = Math.min(r, g, b), sat = mx ? (mx - mn) / mx : 0;
            st.removeProperty('color');
            if (sat > 0.45 && b > r) n.classList.add('dx-acc'); else if (mx < 235 && mx > 110) n.classList.add('dx-mute');
          }
          if (st.borderColor || st.border) { st.removeProperty('border-color'); n.classList.add('dx-line'); }
        });
      }
      var LEG = 'este producto no es un medicamento';
      $$('p,li,div,span,strong,b,em,small', wrap).reverse().forEach(function (n) {
        var tx = n.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
        if (tx.indexOf(LEG) === 0 && tx.length < 260 && n.parentNode) n.remove();
      });
      if (hasFnx) {
        out.classList.add('pdp-desc--fnx');
        var shell = out.closest('.pdp-desc-shell'); if (shell) shell.classList.add('pdp-desc-shell--fnx');
        var sec = out.closest('.pdp-details'); if (sec) sec.classList.add('pdp-details--fnx');
        var h2 = sec && sec.querySelector('.pdp-h2'); if (h2) h2.hidden = true;
      }
      out.appendChild(wrap);
      $$('a[href^="/"]', out).forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (!/^\/(products|collections|pages|blogs|policies)\//.test(href)) return;
        fetch(href, { method: 'HEAD', credentials: 'same-origin' }).then(function (r) { if (r.status === 404) a.replaceWith.apply(a, [].slice.call(a.childNodes)); }).catch(function () {});
      });
      if (!out.textContent.trim()) { var s2 = out.closest('.pdp-details'); if (s2) s2.hidden = true; }
    }
    /* No clamp en HTML editorial fnx (rompe «tres claves» / profundiza) */
    var clampH = +out.dataset.clamp || 0;
    function setClamp() {
      if (!clampH || out.dataset.done || out.classList.contains('pdp-desc--fnx')) return;
      if (out.scrollHeight > clampH * 1.25) {
        out.dataset.done = '1'; out.classList.add('is-clamped'); out.style.setProperty('--clamp', clampH + 'px');
        var b = document.createElement('button'); b.type = 'button'; b.className = 'pdp-more'; b.setAttribute('aria-expanded', 'false'); b.textContent = 'Mostrar más';
        b.addEventListener('click', function () { var open = out.classList.toggle('is-clamped') === false; b.setAttribute('aria-expanded', open); b.textContent = open ? 'Mostrar menos' : 'Mostrar más'; if (!open) out.scrollIntoView({ block: 'nearest' }); });
        out.parentNode.insertBefore(b, out.nextSibling);
      }
    }
    setClamp(); window.addEventListener('load', setClamp);
    $$('img', out).forEach(function (im) { im.addEventListener('load', setClamp); });
  }

  /* ---------- relacionados: destacado + lista paginada (3 por página).
     Tap en fila = destacar (morph FLIP); tap en destacado = abrir ficha. Fusiona las recomendaciones de Shopify. ---------- */
  (function () {
    var root = $('[data-rx]'); if (!root) return;
    var feat = $('#rx-feat', root), list = $('#rx-list', root);
    if (!feat || !list) return;
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var MAX = +root.getAttribute('data-rx-max') || 16, PER = 3, page = 0;
    var R = (root.getAttribute('data-rx-reasons') || 'Muy similar|Ingrediente en común|Misma marca|Complementa|Recomendado|Misma categoría').split('|');
    var RMAP = { s: R[0], i: R[1], v: R[2], c: R[3], r: R[4], k: R[5] };
    var why = {}; try { why = JSON.parse(($('script[data-rx-why]', root) || {}).textContent || '{}'); } catch (e) {}
    var pager = $('[data-rx-pager]', root), lbl = $('[data-rx-pg-l]', root), bar = $('[data-rx-pg-bar]', root),
      prev = $('[data-rx-prev]', root), next = $('[data-rx-next]', root);
    var RANGE = root.getAttribute('data-rx-range') || '__A__-__B__ de __N__ opciones';
    function rows() { return $$('.rx-row', list); }
    function tpl(kind, h) { var t = root.querySelector('template[data-rx-' + kind + '="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"]'); return t ? t.content.cloneNode(true) : null; }
    function kickers() { rows().forEach(function (r) { var k = $('[data-rx-k]', r); if (k) k.textContent = RMAP[why[r.getAttribute('data-rx-h')]] || ''; }); }
    function pages() { return Math.max(1, Math.ceil(rows().length / PER)); }
    /* altura estable: la de la página más alta */
    function sizeList() {
      var rs = rows(); if (!rs.length) return;
      var hid = rs.map(function (r) { var h = r.hidden; r.hidden = false; return h; });
      var max = 0; for (var p = 0; p < rs.length; p += PER) { var s = 0; for (var k = p; k < Math.min(p + PER, rs.length); k++) s += rs[k].offsetHeight; if (s > max) max = s; }
      rs.forEach(function (r, i) { r.hidden = hid[i]; });
      list.style.minHeight = max ? max + 'px' : '';
    }
    function render(dir) {
      var rs = rows(), n = rs.length, P = pages();
      if (page > P - 1) page = P - 1; if (page < 0) page = 0;
      var a = page * PER, b = Math.min(a + PER, n), shown = [];
      rs.forEach(function (r, i) { var on = i >= a && i < b; r.hidden = !on; r.classList.toggle('pg-first', i === a); if (on) shown.push(r); });
      if (pager) {
        pager.hidden = n === 0;
        lbl.textContent = RANGE.replace('__A__', n ? a + 1 : 0).replace('__B__', b).replace('__N__', n);
        if (bar) bar.style.width = (P > 1 ? ((page + 1) / P) * 100 : 100) + '%';
        prev.disabled = page === 0; next.disabled = page >= P - 1;
        pager.classList.toggle('one', P === 1);
      }
      if (dir && !reduce && Element.prototype.animate) shown.forEach(function (r, i) {
        r.animate([{ opacity: 0, transform: 'translateX(' + (dir * 28) + 'px)', filter: 'blur(3px)' }, { opacity: 1, transform: 'none', filter: 'none' }],
          { duration: 420, delay: i * 55, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
      });
    }
    function go(d) {
      var P = pages(), np = Math.min(P - 1, Math.max(0, page + d)); if (np === page) return;
      var out = rows().filter(function (r) { return !r.hidden; });
      var swap = function () { page = np; render(d); };
      if (reduce || !Element.prototype.animate || !out.length) return swap();
      var anims = out.map(function (r, i) { return r.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(' + (-d * 22) + 'px)' }], { duration: 160, delay: i * 25, easing: 'ease-in', fill: 'forwards' }); });
      Promise.all(anims.map(function (x) { return x.finished; })).catch(function () {}).then(function () { anims.forEach(function (x) { x.cancel(); }); swap(); });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    /* deslizar (móvil y trackpad táctil) */
    var sx = 0, sy = 0, st = 0, swiping = false;
    list.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; st = Date.now(); swiping = true; }, { passive: true });
    list.addEventListener('touchend', function (e) {
      if (!swiping) return; swiping = false; var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3 && Date.now() - st < 800) { swipedAt = Date.now(); go(dx < 0 ? 1 : -1); }
    }, { passive: true });
    var swipedAt = 0;
    root.addEventListener('keydown', function (e) {
      if (!list.contains(e.target) && !(pager && pager.contains(e.target))) return;
      if (e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft' || e.key === 'PageUp') { e.preventDefault(); go(-1); }
    });
    var busy = false, EASE = 'cubic-bezier(.22,1,.36,1)', DUR = 600;
    function imgBox(el) {
      // rectángulo real de la imagen dentro de su caja (object-fit: contain)
      var im = el && el.querySelector('img'); var host = el;
      if (!host) return null;
      var r = host.getBoundingClientRect();
      if (!im) return { x: r.left, y: r.top, w: r.width, h: r.height };
      var cs = getComputedStyle(im), pad = parseFloat(cs.paddingLeft) || 0;
      var ir = im.getBoundingClientRect(), bw = ir.width - pad * 2, bh = ir.height - pad * 2;
      var nw = im.naturalWidth || +im.getAttribute('width') || bw, nh = im.naturalHeight || +im.getAttribute('height') || bh;
      var k = Math.min(bw / nw, bh / nh), w = nw * k, h = nh * k;
      return { x: ir.left + pad + (bw - w) / 2, y: ir.top + pad + (bh - h) / 2, w: w, h: h };
    }
    function ghost(fromBox, srcImg, hiImg) {
      var g = document.createElement('div');
      g.className = 'rx-ghost';
      g.style.cssText = 'position:fixed;z-index:60;pointer-events:none;left:' + fromBox.x + 'px;top:' + fromBox.y + 'px;width:' + fromBox.w + 'px;height:' + fromBox.h + 'px';
      [srcImg, hiImg].forEach(function (im, n) {
        if (!im) return;
        var c = document.createElement('img'); c.src = im.currentSrc || im.src; c.alt = '';
        c.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;' + (n ? 'opacity:0;transition:opacity .25s' : '');
        if (n) { var on = function () { c.style.opacity = '1'; }; if (c.complete && c.naturalWidth) setTimeout(on, 120); else c.onload = function () { setTimeout(on, 60); }; }
        g.appendChild(c);
      });
      document.body.appendChild(g);
      return g;
    }
    function fly(g, to) {
      var f = g.getBoundingClientRect();
      return g.animate([
        { left: f.left + 'px', top: f.top + 'px', width: f.width + 'px', height: f.height + 'px' },
        { left: to.x + 'px', top: to.y + 'px', width: to.w + 'px', height: to.h + 'px' }
      ], { duration: DUR, easing: EASE, fill: 'forwards' }).finished;
    }
    function promote(row) {
      if (busy) return; busy = true;
      var nh = row.getAttribute('data-rx-h'), oh = feat.getAttribute('data-rx-cur');
      var nf = tpl('f', nh), nr = tpl('r', oh);
      if (!nf || !nr) { busy = false; return; }
      var newRow = nr.querySelector('.rx-row');
      function commit() {
        feat.innerHTML = ''; feat.appendChild(nf); feat.setAttribute('data-rx-cur', nh);
        row.replaceWith(newRow); kickers(); render(0);
        var p = $('.rx-pick', newRow); if (p && kbd) p.focus({ preventScroll: true });
      }
      if (reduce || !Element.prototype.animate) { commit(); busy = false; return; }
      var thumbHost = $('.rx-th', row), featHost = $('.rx-fimg', feat);
      var fromThumb = imgBox(thumbHost), fromFeat = imgBox(featHost);
      var thumbImg = thumbHost && thumbHost.querySelector('img'), featImg = featHost && featHost.querySelector('img');
      var gIn = fromThumb ? ghost(fromThumb, thumbImg, $('.rx-fimg img', nf)) : null;
      var gOut = fromFeat ? ghost(fromFeat, featImg, null) : null;
      var oldCopy = $('.rx-fcopy', feat);
      if (thumbHost) thumbHost.style.visibility = 'hidden';
      if (featHost) featHost.style.visibility = 'hidden';
      var fadeOld = oldCopy ? oldCopy.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-8px)' }], { duration: 170, easing: 'ease-in', fill: 'forwards' }).finished : Promise.resolve();
      var rowText = $('.rx-rc', row); if (rowText) rowText.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 170, fill: 'forwards' });
      fadeOld.then(function () {
        commit();
        var nHost = $('.rx-fimg', feat), rHost = $('.rx-th', newRow), nCopy = $('.rx-fcopy', feat), rText = $('.rx-rc', newRow), plus = $('.rx-plus', newRow);
        if (nHost) nHost.style.visibility = 'hidden';
        if (rHost) rHost.style.visibility = 'hidden';
        var toFeat = imgBox(nHost), toRow = imgBox(rHost);
        if (nCopy) nCopy.animate([{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: 180, easing: EASE, fill: 'backwards' });
        [rText, plus].forEach(function (el) { if (el) el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, delay: 300, easing: 'ease-out', fill: 'backwards' }); });
        newRow.animate([{ boxShadow: '0 0 0 1px rgba(25,207,255,.55), 0 18px 40px -20px rgba(25,207,255,.8)' }, { boxShadow: '0 0 0 0 rgba(25,207,255,0)' }], { duration: 900, delay: 350, easing: 'ease-out' });
        var jobs = [];
        if (gIn && toFeat) jobs.push(fly(gIn, toFeat));
        if (gOut && toRow) jobs.push(fly(gOut, toRow));
        Promise.all(jobs).catch(function () {}).then(function () {
          if (nHost) nHost.style.visibility = '';
          if (rHost) rHost.style.visibility = '';
          [gIn, gOut].forEach(function (g) { if (g) g.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 120, fill: 'forwards' }).finished.then(function () { g.remove(); }); });
          busy = false;
        });
      });
    }
    var kbd = false;
    root.addEventListener('keydown', function () { kbd = true; });
    root.addEventListener('pointerdown', function () { kbd = false; });
    list.addEventListener('click', function (e) { var b = e.target.closest('.rx-pick'); if (!b || Date.now() - swipedAt < 400) return; promote(b.closest('.rx-row')); });
    /* Fusión con la Product Recommendations API de Shopify: related al inicio, complementary al final; sin duplicados; tope MAX */
    function merge(html, intent) {
      var box = document.createElement('div'); box.innerHTML = html;
      var src = box.querySelector('[data-rx-recs]'); if (!src) return 0;
      var have = {}; have[feat.getAttribute('data-rx-cur')] = 1; rows().forEach(function (r) { have[r.getAttribute('data-rx-h')] = 1; });
      var added = [];
      $$('template[data-rx-r]', src).forEach(function (t) {
        var h = t.getAttribute('data-rx-r');
        if (h === feat.getAttribute('data-rx-cur')) return;
        var ft = src.querySelector('template[data-rx-f="' + h + '"]');
        if (!root.querySelector('template[data-rx-r="' + h + '"]')) { root.appendChild(t); if (ft) root.appendChild(ft); }
        var existing = list.querySelector('.rx-row[data-rx-h="' + h + '"]');
        if (intent === 'related') { if (existing) existing.remove(); if (!why[h]) why[h] = 'r'; added.push(h); }
        else if (!existing) { why[h] = 'c'; added.push(h); }
      });
      if (!added.length) return 0;
      var frag = document.createDocumentFragment();
      added.forEach(function (h) { var c = tpl('r', h); if (c) frag.appendChild(c); });
      if (intent === 'related') list.insertBefore(frag, list.firstChild); else list.appendChild(frag);
      var rs = rows(); for (var i = rs.length - 1; i >= MAX - 1; i--) rs[i].remove(); // tope (MAX incluye el destacado)
      return added.length;
    }
    var pid = root.getAttribute('data-product-id'), base = root.getAttribute('data-rx-recs-url') || '/recommendations/products';
    function fetchRecs(intent) {
      if (!pid || !window.fetch) return Promise.resolve('');
      /* related: solo las 6 primeras (la cola de Shopify suele ser un relleno por popularidad, igual en todas las fichas) */
      return fetch(base + '?section_id=rx-recs&product_id=' + encodeURIComponent(pid) + '&limit=' + (intent === 'related' ? 6 : 4) + '&intent=' + intent, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    }
    function loadRecs() {
      Promise.all([fetchRecs('related'), fetchRecs('complementary')]).then(function (res) {
        var n = merge(res[0], 'related') + merge(res[1], 'complementary');
        root.setAttribute('data-rx-api', String(n));
        if (n) {
          /* si el destacado era solo un complementario, cede su lugar a la 1.ª recomendación de Shopify (sin animación: ocurre antes de llegar a la sección) */
          var cur = feat.getAttribute('data-rx-cur'), r0 = rows()[0];
          if (why[cur] === 'c' && r0 && why[r0.getAttribute('data-rx-h')] === 'r') {
            var h0 = r0.getAttribute('data-rx-h'), nf = tpl('f', h0), nr = tpl('r', cur);
            if (nf && nr) { feat.innerHTML = ''; feat.appendChild(nf); feat.setAttribute('data-rx-cur', h0); list.appendChild(nr); r0.remove(); }
          }
          kickers(); sizeList(); page = 0; render(0);
        }
      });
    }
    root.classList.add('rx-paged');
    kickers(); sizeList(); render(0);
    addEventListener('resize', function () { sizeList(); });
    addEventListener('load', sizeList);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); loadRecs(); } }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else loadRecs();
  })();

  /* ---------- D6 · zoom de la imagen: <dialog> accesible (foco atrapado por el navegador, Esc cierra y devuelve el foco).
     Clic/tap en la foto o en la lupa abre; dentro: clic (mouse) o doble toque acerca/aleja en ese punto, pellizco, rueda y arrastre; +/−/0 con teclado. ---------- */
  (function () {
    var dlg = $('#pdp-zd'), main = $('#pdp-main');
    if (!dlg || !main || typeof dlg.showModal !== 'function') return;
    var stage = $('[data-zoom-stage]', dlg), img = $('.pdp-zd-img', dlg), opener = null;
    var s = 1, x = 0, y = 0, MAX = 4;
    function apply(an) { img.style.transition = an ? 'transform .3s cubic-bezier(.22,1,.36,1)' : 'none'; img.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + s + ')'; dlg.classList.toggle('is-z', s > 1.01); }
    function clamp() { var r = stage.getBoundingClientRect(), mx = Math.max(0, (img.offsetWidth * s - r.width) / 2), my = Math.max(0, (img.offsetHeight * s - r.height) / 2); x = Math.max(-mx, Math.min(mx, x)); y = Math.max(-my, Math.min(my, y)); }
    function zoomAt(ns, cx, cy, an) { ns = Math.max(1, Math.min(MAX, ns)); var k = ns / s; x = cx - (cx - x) * k; y = cy - (cy - y) * k; s = ns; if (s <= 1.001) { s = 1; x = 0; y = 0; } clamp(); apply(an); }
    function rel(px, py) { var r = stage.getBoundingClientRect(); return [px - r.left - r.width / 2, py - r.top - r.height / 2]; }
    function srcOf() { var t = $('.pdp-thumb[aria-current=true]'); if (t && t.dataset.zoom) return t.dataset.zoom; if (main.dataset.zoom) return main.dataset.zoom; var mi = $('img', main); return mi ? (mi.currentSrc || mi.src) : ''; }
    function open() {
      var u = srcOf(); if (!u) return;
      opener = document.activeElement; s = 1; x = 0; y = 0; apply(false);
      var mi = $('img', main); img.src = u; if (mi && mi.alt) img.alt = mi.alt;
      MAX = 4; var fit = function () { if (img.naturalWidth && img.offsetWidth) MAX = Math.min(4, Math.max(2, img.naturalWidth / img.offsetWidth * 1.25)); }; if (img.complete) fit(); else img.onload = fit;
      dlg.showModal(); document.documentElement.classList.add('zd-open'); if (window.lenis) window.lenis.stop();
      var xb = $('[data-zoom-close]', dlg); if (xb) xb.focus();
    }
    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('zd-open'); if (window.lenis) window.lenis.start(); if (opener && opener.focus) opener.focus({ preventScroll: true }); });
    main.addEventListener('click', function (e) { if (e.target.closest('a')) return; e.preventDefault(); open(); });
    main.addEventListener('keydown', function (e) { if (e.key !== 'Enter' && e.key !== ' ') return; e.preventDefault(); open(); });
    $('[data-zoom-close]', dlg).addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    var pts = new Map(), d0 = 0, s0 = 1, c0 = null, moved = false, lastTap = 0, st = null;
    function two() { var a = []; pts.forEach(function (p) { a.push(p); }); return a; }
    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button')) return;
      try { stage.setPointerCapture(e.pointerId); } catch (er) {}
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY }); moved = false; st = [e.clientX, e.clientY, x, y];
      if (pts.size === 2) { var a = two(); d0 = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) || 1; s0 = s; c0 = rel((a[0].x + a[1].x) / 2, (a[0].y + a[1].y) / 2); moved = true; }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!pts.has(e.pointerId)) return; pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 2) { var a = two(); zoomAt(s0 * Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) / d0, c0[0], c0[1], false); }
      else if (pts.size === 1 && st) { var dx = e.clientX - st[0], dy = e.clientY - st[1]; if (Math.abs(dx) + Math.abs(dy) > 5) moved = true; if (s > 1) { x = st[2] + dx; y = st[3] + dy; clamp(); apply(false); } }
    });
    function up(e) {
      if (!pts.has(e.pointerId)) return; pts.delete(e.pointerId);
      if (pts.size === 1) { var p = two()[0]; st = [p.x, p.y, x, y]; return; }
      if (pts.size || moved) return;
      var c = rel(e.clientX, e.clientY);
      var ir = img.getBoundingClientRect(), onImg = e.clientX >= ir.left && e.clientX <= ir.right && e.clientY >= ir.top && e.clientY <= ir.bottom; /* con captura de puntero el target es el escenario */
      if (!onImg) { if (s === 1) close(); return; }
      if (e.pointerType === 'mouse') { zoomAt(s > 1 ? 1 : 2.2, c[0], c[1], true); return; }
      var now = Date.now(); if (now - lastTap < 320) { zoomAt(s > 1 ? 1 : 2.5, c[0], c[1], true); lastTap = 0; } else lastTap = now;
    }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', function (e) { pts.delete(e.pointerId); });
    stage.addEventListener('wheel', function (e) { e.preventDefault(); var c = rel(e.clientX, e.clientY); zoomAt(s * Math.exp(-e.deltaY * 0.0018), c[0], c[1], false); }, { passive: false });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === '+' || e.key === '=') { e.preventDefault(); zoomAt(s * 1.4, 0, 0, true); }
      else if (e.key === '-' || e.key === '_') { e.preventDefault(); zoomAt(s / 1.4, 0, 0, true); }
      else if (e.key === '0') { e.preventDefault(); zoomAt(1, 0, 0, true); }
    });
    addEventListener('resize', function () { if (dlg.open) { clamp(); apply(false); } });
    NM.pdpZoom = { open: open, close: close, state: function () { return { s: s, x: x, y: y, open: dlg.open }; } };
  })();

  /* ---------- D6 · inclinación sutil del frasco: solo escritorio con mouse, nunca con «Reducir movimiento» ---------- */
  (function () {
    var m = $('#pdp-main[data-tilt]'), R = document.documentElement;
    if (!m || R.classList.contains('rm') || !matchMedia('(hover:hover) and (pointer:fine)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var raf = 0, tx = 0, ty = 0; m.classList.add('can-tilt');
    m.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = m.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width - 0.5; ty = (e.clientY - r.top) / r.height - 0.5;
      if (!raf) raf = requestAnimationFrame(function () {
        raf = 0; m.classList.add('is-tilt');
        m.style.setProperty('--ry', (tx * 10).toFixed(2) + 'deg'); m.style.setProperty('--rx', (-ty * 8).toFixed(2) + 'deg');
        m.style.setProperty('--mx', ((tx + 0.5) * 100).toFixed(1) + '%'); m.style.setProperty('--my', ((ty + 0.5) * 100).toFixed(1) + '%');
      });
    });
    m.addEventListener('pointerleave', function () { m.classList.remove('is-tilt'); m.style.setProperty('--rx', '0deg'); m.style.setProperty('--ry', '0deg'); });
  })();

  /* ---------- P6 · luz de lectura en la descripción: la línea bajo el cursor se aclara con una luz suave (sin lupa, sin mover
     el texto). Solo escritorio con mouse; nunca con «Reducir movimiento». Se activa al primer paso del cursor (no afecta la carga). ---------- */
  (function () {
    var d = $('#pdp-desc'), R = document.documentElement;
    if (!d || !window.matchMedia || R.classList.contains('rm') || !matchMedia('(hover:hover) and (pointer:fine)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var glow = null, cur = null, ev = null, raf = 0, SEL = 'p,li';
    function ok(el) {
      if (!el || !d.contains(el) || el.closest('table,details,.dx-card,button,a[class]')) return false;
      if (el._rfOk !== undefined) return el._rfOk;
      var cs = getComputedStyle(el);
      return (el._rfOk = cs.backgroundImage === 'none' && /rgba\(0, 0, 0, 0\)|transparent/.test(cs.backgroundColor) && !!el.textContent.trim());
    }
    function setCur(el) {
      if (cur === el) return;
      if (cur) { cur.classList.remove('rf-cur'); cur.style.removeProperty('--rf-base'); cur.style.removeProperty('--rfx'); cur.style.removeProperty('--rfy'); }
      cur = el;
      if (cur) { cur.style.setProperty('--rf-base', getComputedStyle(cur).color); cur.classList.add('rf-cur'); }
    }
    function draw() {
      raf = 0; if (!ev) return;
      var dr = d.getBoundingClientRect();
      glow.style.transform = 'translate3d(' + (ev.clientX - dr.left).toFixed(1) + 'px,' + (ev.clientY - dr.top).toFixed(1) + 'px,0)';
      var t = ev.target && ev.target.closest ? ev.target.closest(SEL) : null;
      setCur(ok(t) ? t : null);
      if (cur) { var r = cur.getBoundingClientRect(); cur.style.setProperty('--rfx', (ev.clientX - r.left).toFixed(1) + 'px'); cur.style.setProperty('--rfy', (ev.clientY - r.top).toFixed(1) + 'px'); }
    }
    function init() {
      glow = document.createElement('span'); glow.className = 'rf-glow'; glow.setAttribute('aria-hidden', 'true');
      d.insertBefore(glow, d.firstChild); d.classList.add('rf-on');
      d.addEventListener('pointermove', function (e) { if (e.pointerType !== 'mouse') return; ev = e; if (!raf) raf = requestAnimationFrame(draw); });
      d.addEventListener('pointerleave', function () { ev = null; d.classList.remove('rf-in'); setCur(null); });
    }
    d.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (!glow) init();
      d.classList.add('rf-in'); ev = e; if (!raf) raf = requestAnimationFrame(draw);
    });
  })();

  if (!form) return;

  /* ---------- galería ---------- */
  var main = $('#pdp-main');
  $$('.pdp-thumb').forEach(function (b) {
    b.addEventListener('click', function () {
      var im = main && main.querySelector('img'); if (!im) return;
      im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = b.dataset.full; im.alt = b.dataset.alt || '';
      $$('.pdp-thumb').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
    });
  });

  /* ---------- cantidad ---------- */
  var qty = $('input[name=quantity]', form);
  $$('.qbtn', form).forEach(function (b) {
    b.addEventListener('click', function () { var v = Math.max(1, Math.min(99, (+qty.value || 1) + (+b.dataset.q))); qty.value = v; });
  });

  /* ---------- variantes ---------- */
  var P = null; try { P = JSON.parse(jsonEl.textContent); } catch (e) {}
  var idEl = $('#pdp-variant'), addBtn = $('#pdp-add'), barBtn = $('#pdp-bar-add'), price = $('#pdp-price'), barPrice = $('#pdp-bar-price');
  var S = NM.strings || {}, T_ADD = addBtn ? addBtn.dataset.add || addBtn.textContent.trim() : '', T_OUT = '';
  if (addBtn && !addBtn.disabled) addBtn.dataset.add = T_ADD;
  function fmt(c) { return NM.money ? NM.money(c) : '$' + Math.round(c / 100); }
  function current() {
    var vals = [];
    $$('[data-option-index]', form).forEach(function (el) {
      var i = +el.dataset.optionIndex;
      if (el.tagName === 'SELECT') vals[i] = el.value; else if (el.checked) vals[i] = el.value;
    });
    return vals;
  }
  function upd() {
    if (!P) return;
    var vals = current();
    var v = P.variants.filter(function (x) { var o = x.options || [x.option1, x.option2, x.option3].filter(Boolean); return vals.every(function (val, i) { return val === undefined || o[i] === val; }); })[0];
    var nx = $('#pdp-next-add'), nav = $('[data-next-av]');
    if (v && nx) { nx.disabled = !v.available; nx.setAttribute('aria-disabled', String(!v.available)); var ns = $('span', nx); if (ns) ns.textContent = v.available ? (addBtn.dataset.add || 'Agregar al carrito') : (NM.strings && NM.strings.soldOut) || 'Agotado'; }
    if (v && nav) { nav.classList.toggle('is-out', !v.available); $('span', nav).textContent = v.available ? nav.dataset.in : nav.dataset.out; }
    var sc = $('[data-stock]'); if (v && sc) { sc.classList.toggle('is-out', !v.available); $('span', sc).textContent = v.available ? sc.dataset.in : sc.dataset.out; }
    [addBtn, barBtn].forEach(function (b) { if (!b) return; if (!v) { b.disabled = true; return; } b.disabled = !v.available; b.textContent = v.available ? (b.dataset.add || addBtn.dataset.add || 'Agregar al carrito') : (window.NM && NM.strings && NM.strings.soldOut) || 'Agotado'; });
    if (!v) return;
    idEl.value = v.id;
    var bs = $('#pdp-bar-var'); if (bs) bs.value = String(v.id);
    var html = (v.compare_at_price > v.price ? '<s class="was">' + fmt(v.compare_at_price) + '</s> ' : '') + fmt(v.price);
    if (price) price.innerHTML = html; if (barPrice) barPrice.textContent = fmt(v.price);
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
  }
  $$('[data-option-index]', form).forEach(function (el) { el.addEventListener('change', upd); });
  var qv = new URLSearchParams(location.search).get('variant');
  if (qv && P) { var vv = P.variants.filter(function (x) { return String(x.id) === qv; })[0]; if (vv) { var o = vv.options || []; o.forEach(function (val, i) { $$('[data-option-index="' + i + '"]', form).forEach(function (el) { if (el.tagName === 'SELECT') el.value = val; else el.checked = el.value === val; }); }); upd(); } }

  /* ---------- cierre «Siguiente paso»: agrega la variante elegida con el mismo flujo del formulario (abre el carrito y lo actualiza) ---------- */
  var nextAdd = $('#pdp-next-add');
  if (nextAdd && addBtn) nextAdd.addEventListener('click', function () { if (nextAdd.disabled || addBtn.disabled) return; addBtn.click(); });

  /* ---------- barra fija de compra: visible cuando el botón «Agregar» no está en pantalla; oculta con el carrito abierto ---------- */
  var bar = $('#pdp-bar'), barSel = $('#pdp-bar-var');
  if (bar && addBtn) {
    var buyOut = false, nextVis = false, footVis = false, root = document.documentElement;
    function setBar() {
      var drawerOpen = document.body.classList.contains('drawer-open');
      var show = buyOut && !drawerOpen && !nextVis && !footVis;
      if (show === bar.classList.contains('show')) return;
      bar.classList.toggle('show', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      root.classList.toggle('pbar-on', show);
      if (show) root.style.setProperty('--pbh-live', (bar.getBoundingClientRect().height + 12) + 'px');
    }
    if ('IntersectionObserver' in window) {
      /* D1: el botón real manda — si no está en pantalla (arriba, o abajo en teléfonos chicos al cargar) la barra lo sustituye */
      new IntersectionObserver(function (a) { var e = a[0]; buyOut = !e.isIntersecting; setBar(); }, { threshold: 0.6 }).observe(addBtn);
    }
    /* también se oculta mientras el bloque de cierre «¿Listo para continuar?» está en pantalla */
    var nextBlk = $('.pdp-next');
    if (nextBlk && 'IntersectionObserver' in window) new IntersectionObserver(function (a) { nextVis = a[0].isIntersecting; setBar(); }, { threshold: 0.15 }).observe(nextBlk);
    /* y mientras el pie (con la leyenda legal) está en pantalla: nunca la tapa */
    var footBlk = $('.site-footer') || $('footer');
    if (footBlk && 'IntersectionObserver' in window) new IntersectionObserver(function (a) { footVis = a[0].isIntersecting; setBar(); }, { threshold: 0 }).observe(footBlk);
    new MutationObserver(setBar).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    if (barSel && P) {
      barSel.addEventListener('change', function () {
        var v = P.variants.filter(function (x) { return String(x.id) === barSel.value; })[0]; if (!v) return;
        var o = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        o.forEach(function (val, i) { $$('[data-option-index="' + i + '"]', form).forEach(function (el) { if (el.tagName === 'SELECT') el.value = val; else el.checked = el.value === val; }); });
        upd();
      });
    }
  }
})();
